import useSWR, { KeyedMutator } from "swr";
import { useDataCleaningContext } from "../context/data-cleaning-context";
import {
  EntityFieldItem,
  EntityFieldsResponse,
  TableInfo,
  getEntityFields,
} from "../services/cleaning-data-service";

export interface UseEntityFieldsReturn {
  fields: EntityFieldItem[] | undefined;
  availableTables: TableInfo[] | undefined;
  isLoading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: KeyedMutator<EntityFieldsResponse>;
}

const useEntityFields = (): UseEntityFieldsReturn => {
  const { selection } = useDataCleaningContext();
  const { selectedEntityId, selectedFieldId } = selection;
  let key: string | null = null;
  if (selectedFieldId !== undefined) {
    key = `/fields/source/${selectedFieldId}`;
  } else if (selectedEntityId !== undefined) {
    key = `/fields/${selectedEntityId}`;
  }

  const { data, error, mutate } = useSWR(key, () =>
    getEntityFields(selectedEntityId, selectedFieldId),
  );

  return {
    fields: data?.results,
    availableTables: data?.availableTables,
    isLoading: !error && !data && key !== null,
    error,
    mutate,
  };
};

export default useEntityFields;
